// React
import React from "react";

// Internal
import {getDataTestId} from "../functions/data-test-ids";
import {Tooltip} from "../tooltip/tooltip";

// CSS
import "./radio.css";

const RadioGroupAlignment = {
    Center: 1,
    Left: 2,
    Right: 3
}

function RadioButtonBadge(props) {
    if (!props.Text) {
        return null;
    }
    
    return (
        <div className="eone-ui-radio-button-badge">{props.Text}</div>
    );
}

function RadioButton(props) {
    const change = () => {
        if (typeof props.OnChange === "function") {
            props.OnChange(props.Value);
        }
    };

    return (
        <div className="eone-ui-radio-button-label-container">
            <input type="radio" aria-label={props.Label} className="eone-ui-radio-button" id={props.Id} name={props.GroupId} checked={props.Checked} onChange={change} data-testid={getDataTestId(props.DataTestId, props.Value)} />
            <span className="eone-ui-radio-button-label">{props.Label}</span>
            <RadioButtonBadge Text={props.BadgeText} />
            <Tooltip
                Title={props.TooltipTitle || props.Label}
                Tooltip={props.Tooltip}
                TooltipWidth={props.TooltipWidth}
                DataTestId={props.DataTestId}/>
        </div>
    );
}

function RadioGroup(props) {
    const change = (value) => {
        if (typeof props.OnChange === "function") {
            props.OnChange(value);
        }
    };

    const getButtons = () => {
        return props.Buttons.map((button, index) => {
            if (button.Visible === undefined || button.Visible === true) {
                return (
                    <RadioButton
                        key={index}
                        Value={button.Value}
                        Id={button.Id}
                        Label={button.Label}
                        BadgeText={button.BadgeText}
                        GroupId={props.GroupId}
                        Checked={button.Value === props.Value}
                        OnChange={change}
                        Tooltip={button.Tooltip}
                        DataTestId={props.DataTestId} />
                );
            }
        });
    };

    const getClass = () => {
        let className = "eone-ui-radio-group";
        switch (props.Alignment) {
            case RadioGroupAlignment.Left:
                className = className + " eone-ui-radio-group-left";
                break;
            case RadioGroupAlignment.Right:
                className = className + " eone-ui-radio-group-right";
                break;
            default:
                className = className + " eone-ui-radio-group-center";
                break;
        }
        return className;
    };

    if (props.Visible !== undefined && !props.Visible) {
        return null;
    }

    return (
        <div className={getClass()}>
            {getButtons()}
        </div>
    );

}

export { RadioGroup, RadioGroupAlignment };